// Approved_Pilots.Interest picklist options (mirrors APPROVED_PILOT_INTERESTS
// in services/pilot.service.js). One list, every add/confirm surface.
export const PILOT_INTERESTS = [
  { value: 'Permissive User', label: 'Permissive User' },
  { value: 'Owner', label: 'Owner (co-owner)' },
  { value: 'CFI', label: 'CFI' },
  { value: 'Professional Pilot', label: 'Professional Pilot' },
  { value: 'Spouse', label: 'Spouse' },
  { value: 'Not on Aircraft', label: 'Not on Aircraft' },
];
